import { Pipe, PipeTransform } from '@angular/core';
import { Category } from '@interfaces/Category';
import { DepartmentEstimate } from '@interfaces/DepartmentEstimate';

@Pipe({
  name: 'internalFeeBillableFinal'
})
export class InternalFeeBillableFinalPipe implements PipeTransform {
  public transform(element: DepartmentEstimate | Category): number {
    return element.estimateLines.reduce((billableFinal, estimateLine) => {
      if (estimateLine.internalFeeBillableFinal !== null) {
        return billableFinal + estimateLine.internalFeeBillableFinal;
      } else {
        return (
          billableFinal +
          estimateLine.internalFeeLines.map(l => l.quantity * l.rateBillable).reduce((sum, element) => sum + element, 0)
        );
      }
    }, 0);
  }
}
